import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last
      });
    },

    async createOtherInfo(context, otherInfo) {
      if (otherInfo.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/other-info`,
            data: {
              accountId: otherInfo.accountId,
              customerId: otherInfo.customerId,
              label: otherInfo.label,
              listItemId: otherInfo.listItemId,
              detail: otherInfo.detail
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/otherInfos/delete", {
            where: otherInfo.tempId
          });
          store.dispatch("entities/otherInfos/insert", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async updateOtherInfo(context, otherInfo) {
      if (otherInfo.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/other-info/${otherInfo.id}`,
            data: {
              accountId: otherInfo.accountId,
              id: otherInfo.id,
              label: otherInfo.label,
              listItemId: otherInfo.listItemId,
              detail: otherInfo.detail
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/otherInfos/update", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
          return false;
        }
      }
    },

    async deleteOtherInfo(context, otherInfo) {
      const store = this;
      store.dispatch("entities/otherInfos/delete", otherInfo.id);

      if (otherInfo.isDirty === true) {
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/other-info/${otherInfo.id}`,
            data: {
              accountId: otherInfo.accountId,
              id: otherInfo.id,
              deleted: true
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
          return false;
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/other-info?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let otherInfos = [];
    obj.forEach(function(otherInfo) {
      otherInfos.push({
        accountId: otherInfo.accountId,
        id: otherInfo.id,
        isDirty: false,
        customerId: otherInfo.customerId,
        label: otherInfo.label,
        detail: otherInfo.detail,
        createdAt: Date.parse(otherInfo.createdAt),
        updatedAt: Date.parse(otherInfo.updatedAt)
      });
    });
    if (otherInfos.length > 0) {
      store.dispatch("entities/otherInfos/insert", {
        data: otherInfos
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
